import { render, staticRenderFns } from "./WEditDialog.vue?vue&type=template&id=b55d62e6&scoped=true&"
import script from "./WEditDialog.vue?vue&type=script&lang=js&"
export * from "./WEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d62e6",
  null
  
)

export default component.exports